import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './WithdrawalForm.css';
import { toast } from 'react-toastify';
import { INSTRUCTOR_URL } from '../../Services/Services';

const PaymentInfo = () => {
  const [method, setMethod] = useState('bank');
  const [accountNumber, setAccountNumber] = useState('');
  const [ifscCode, setIfscCode] = useState('');
  const [fullName, setFullName] = useState('');
  const [error, setError] = useState('');
  const [isAccountSaved, setIsAccountSaved] = useState(false);
  const [showWithdrawalLoading, setShowWithdrawalLoading] = useState(false);
  const instructorId = localStorage.getItem('userId');

  useEffect(() => {
    const checkAccountDetails = async () => {
      try {
        const response = await axios.get(`${INSTRUCTOR_URL}/payment-account/${instructorId}`);
        if (response.status === 200) {
          const { accountName, accountNumber, ifscCode } = response.data;
          setFullName(accountName);
          setAccountNumber(accountNumber);
          setIfscCode(ifscCode);
          setIsAccountSaved(true);
        }
      } catch (error) {
        if (error.response && error.response.status === 404) {
          setIsAccountSaved(false);
        }
      }
    };

    checkAccountDetails();
  }, [instructorId]);

  const handleMethodChange = (e) => {
    setMethod(e.target.value);
    setError('');
  };

  const validateBankDetails = () => {
    const accountNumberRegex = /^[0-9]{9,18}$/;
    const ifscRegex = /^[A-Za-z]{4}0[A-Za-z0-9]{6}$/;

    if (!fullName.trim()) {
      return 'Full name is required.';
    }

    if (!accountNumberRegex.test(accountNumber)) {
      return 'Please enter a valid account number (9-18 digits).';
    }

    if (!ifscCode) {
      return 'IFSC code is required.';
    }

    if (!ifscRegex.test(ifscCode)) {
      return 'Please enter a valid IFSC code (4 letters, 0, and 6 alphanumeric characters).';
    }

    return '';
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let validationError = validateBankDetails();

    if (validationError) {
      setError(validationError);
      return;
    }

    setShowWithdrawalLoading(true);

    try {
      const response = await axios.post(`${INSTRUCTOR_URL}/${instructorId}/add-payment-account`, {
        accountName: fullName,
        accountNumber,
        ifscCode,
      });

      toast.dismiss();
      if (response.status === 201) {
        toast.success('Account details saved successfully!');
        setIsAccountSaved(true);
      }
    } catch (error) {
      toast.dismiss();
      if (error.response && error.response.status === 400) {
        toast.error(error.response.data || 'Bad request: Please check the input or data.');
      } else if (error.response && error.response.data.message) {
        toast.error(error.response.data.message || 'Error processing updating payment info.');
      } else {
        toast.error('An error occurred while updating payment info.');
      }
    } finally {
      setShowWithdrawalLoading(false);
    }
  };

  return (
    <div className="withdrawal-form">
      <h2 className="report-title">Payment Information</h2>
      <form className="withdrawal-form__form" onSubmit={handleSubmit}>
        <div className="withdrawal-form__method-selection">
          <label className="withdrawal-form__method-option">
            <input
              type="radio"
              value="bank"
              checked={method === 'bank'}
              onChange={handleMethodChange}
              className="withdrawal-form__radio"
            />
            Bank Account
          </label>
        </div>

        {method === 'bank' && (
          <div className="withdrawal-form__bank-details">
            <div className="withdrawal-form__input-group">
              <label className="withdrawal-form__label">Full Name</label>
              <input
                type="text"
                value={fullName}
                onChange={(e) => setFullName(e.target.value)}
                placeholder={isAccountSaved ? '' : 'Enter your full name'}
                className="withdrawal-form__input withdrawal-form__input--full-name"
                required
              />
            </div>
            <div className="withdrawal-form__input-group">
              <label className="withdrawal-form__label">Bank Account Number</label>
              <input
                type="text"
                value={accountNumber}
                onChange={(e) => setAccountNumber(e.target.value)}
                placeholder={isAccountSaved ? '' : 'Enter your bank account number'}
                className="withdrawal-form__input withdrawal-form__input--account-number"
                required
              />
            </div>
            <div className="withdrawal-form__input-group">
              <label className="withdrawal-form__label">IFSC Code</label>
              <input
                type="text"
                value={ifscCode}
                onChange={(e) => setIfscCode(e.target.value)}
                placeholder={isAccountSaved ? '' : 'Enter your IFSC code'}
                className="withdrawal-form__input withdrawal-form__input--ifsc"
                required
              />
            </div>
          </div>
        )}

        {error && <div className="withdrawal-form__error">{error}</div>}

        <div className="withdrawal-form__submit">
          <button type="submit" className="withdrawal-form__button" disabled={showWithdrawalLoading}>
            {showWithdrawalLoading ? 'Saving...' : (isAccountSaved ? 'Update Account Details' : 'Save Account Details')}
          </button>
        </div>
      </form>

    </div>
  );
};

export default PaymentInfo;
